import Select from "react-select";
import { useEffect, useState } from 'react';
import { getAxiosResponse, deleteAxiosResponse, postAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { useParams } from 'react-router-dom';
import { CrossIcon } from "../../AppIcons";
import { useTranslation } from "react-i18next"

export default function ReferenceMaterialUpload(props) {    

  const params = useParams()

  const [TMList, setTMList] = useState([]);

  const [selectedTMs, setSelectedTMs] = useState([]);
  
  const [glossary, setGlossary] = useState([]);
  
  const [styleGuide, setStyleGuide] = useState([]);
  
  const [departmentTm, setDepartmentTm] = useState([]);
  
  const { t } = useTranslation();
  const translate = t;

  useEffect(()=>{    
    updateCustomTMSelection();
    getAxiosResponse(APIUrls?.TM_DEPARTMENT).then(res => {
      if (res?.data?.data && res?.data?.data?.length > 0) {        
        setDepartmentTm(res?.data?.data);
      }
    })
    getAxiosResponse(APIUrls.GET_CUSTOMER_STYLE_GUIDE)
      .then((res) => {
        if (res.data !== "") {          
          setStyleGuide(res.data);
        }
      })
      getAxiosResponse(APIUrls.GLOSSARY_DEPARTMENT)
      .then((res) => {
        if (res?.data) {                    
          setGlossary(res?.data);
        }
      })
  },[])

  function updateCustomTMSelection(){
    getAxiosResponse(APIUrls.FILTERED_PROJECT_UBER_TM(props.projectId)).then((res)=>{      
      let customTMList = res?.data?.data?.customTMList;
      let projectUberTmList = res?.data?.data?.projectUberTmList;
      let filteredTMs = customTMList?.map(tm=>{  return {label :tm?.name, value:tm?.id} });          
      let projectUberTmFilteredList = projectUberTmList?.map(tm => {return {label :tm?.uberTmEntity?.name, value:tm?.id}})        
      setSelectedTMs(projectUberTmFilteredList);        
      setTMList(filteredTMs);        
    });    
  }



  const selectTM = (event) =>{           
    postAxiosResponse(APIUrls.PROJECT_UBER_TM,{
      "uberTmEntity":{
              "id" : event.value
      },
      "projectId":params.id  
  
  }).then(res=>{
    updateCustomTMSelection();
    })
  }

  const removeTm=(tm)=>{        
        deleteAxiosResponse(APIUrls.PROJECT_UBER_TM_DELETE(tm.value)).then(res=>{
          updateCustomTMSelection();
        });        
  }
  
  return (

    <div className="tab-box col-md-9">
      {
        glossary.length ? 
        <div><strong>{translate("translation_material.glossary")}</strong>: {translate("translation_material.glossary_available_message")}</div> :
        <div><strong>{translate("translation_material.glossary")}</strong>: {translate("translation_material.glossary_unavailable_message")}</div>
      }       
      <br/>
      <br/>
      {(styleGuide.data  && styleGuide.data.id)?
        <div><strong>{translate("translation_material.style.guide")}</strong>: {translate("translation_material.style_guide_available_message")}</div>:
        <div><strong>{translate("translation_material.style.guide")}</strong>: {translate("translation_material.style_guide_unavailable_message")}</div>
      }            
      <br/>
      <br/>
      {
        departmentTm.length ?
        <div><strong>{translate("translation_material.translation.memory")}</strong>: {translate("translation_material.glossary_department_available_message")}</div>:
        <div><strong>{translate("translation_material.translation.memory")}</strong>: {translate("translation_material.glossary_department_unavailable_message")} <a href="https://cloudwords.zendesk.com/entries/358485">Learn more</a>.</div>
      }
      <div className="global-dropdown-block flex-center sourcFocus">
      <div className="global-dropdown-select">
      <label>Include Custom TM : </label> <Select 
								className="global-dropdown-select requiredInput" classNamePrefix='cw'
								name="Source Language"
								aria-label="Source Language"
								placeholder="Select"
								options={TMList}
								onChange={(event) => selectTM(event)}
								value={{
									label: "--Select Translation--",
									value: ""
								}}
							>
		    </Select>
        </div>
        </div>
        <div class="multiselect-output flex">
        {selectedTMs &&
								selectedTMs.map(tm => (
									<button aria-label={'remove ' + tm.label} onClick={()=>removeTm(tm)}>
                                        <strong>{tm.label}</strong>
                                    {CrossIcon}
                                    </button>
								))}            
        </div>      
    </div>
  );
}
